import { render } from "./TradeDealDetailsTable.vue?vue&type=template&id=07a5ce03&ts=true"
import script from "./TradeDealDetailsTable.vue?vue&type=script&lang=ts"
export * from "./TradeDealDetailsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__